import Vue from 'vue'
import Vuex from 'vuex'
import nav from '@/containers/_nav'

Vue.use(Vuex);

const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    permissions: JSON.parse(localStorage.getItem('permissions') || '{}'),
    isLoggedIn: localStorage.getItem('apiToken') ? true : false,
    loggedInUserId: localStorage.getItem('loggedInUserId') || '',
    loggedInUserEmail: localStorage.getItem('loggedInUserEmail') || '',
    avatarUrl: localStorage.getItem('avatarUrl') || '',
    contractSelectedUtility: null,
    navBarItems: nav || [],
    selectedContractId: null,
    contractProducts: null,
    isContractSellback: false,
    contractVolumeUnit: "",
    contractTradeUnit: "",
    contractVolumeUnitName: "",
    contractTradeUnitName: "", 
    whatIfUtilityTypeId: null,
    whatIfProducts: null,
    whatIfTradeablePeriods: null,
    whatIfPriceUnit: null,
    whatIfTradingSymbol: null,
    whatIfLockedVolumeUnit: null,
    whatIfTradeCurrency: null,
    whatIfRoute: null,
    wahtIfObject: null,
    reportContractId: null,
    reportClientId: null,
    reportTradingGroupId: null,
    contractMarketUnit: "",
    contractMarketUnitName: "",
    contractHasActiveTrades: false,
    isContractExpired: false,
    isGroupUserTabLast: false,
    isCheckDefaultM:false,
    isClientDefaultM: !!JSON.parse(localStorage.getItem('defaultMech')) || false,
    homeVolumeData: {},
    homePowerRates: [],
    homeGasRates: [],
    whatIfCollection: [],
    homeRegionMap: [],
    pricingAreaNames: null,
    hasPriceAreas: false
}

const mutations = {
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
        state[variable] = value
    },
    setPermissions(state, permissions) {
        state.permissions = permissions
    },
    setIsLoggedIn(state, value) {
        state.isLoggedIn = value
    },
    setLoggedInUserId(state, value) {
        state.loggedInUserId = value
    },
    setLoggedInUserEmail(state, value) {
        state.loggedInUserEmail = value
    },
    setAvatarUrl(state, value) {
        state.avatarUrl = value
    },
    setNavBarItems(state, value) {
        state.navrBarItems = value
    },
    setCurrentContractId(state, value) {
        state.selectedContractId = value;
    },
    setContractProducts(state, value) {
        state.contractProducts = value;
    },
    setIsContractSellback(state, value) {
        state.isContractSellback = value;
    },
    setContractVolumeUnit(state, value) {
        state.contractVolumeUnit = value;
    },
    setContractTradeUnit(state, value) {
        state.contractTradeUnit = value;
    },
    setContractVolumeUnitName(state, value) {
        state.contractVolumeUnitName = value;
    },
    setContractTradeUnitName(state, value) {
        state.contractTradeUnitName = value;
    }, 
    setWhatIfUtilityTypeId(state, value) {
        state.whatIfUtilityTypeId = value;
    },
    setWhatIfProducts(state, value) {
        state.whatIfProducts = value;
    },
    setWhatIfTradeablePeriods(state, value) {
        state.whatIfTradeablePeriods = value;
    },
    setWhatIfPriceUnit(state, value) {
        state.whatIfPriceUnit = value;
    },
    setWhatIfTradingSymbol(state, value) {
        state.whatIfTradingSymbol = value;
    },
    setWhatIfLockedVolumeUnit(state, value) {
        state.whatIfLockedVolumeUnit = value;
    },
    setWhatIfTradeCurrency(state, value) {
        state.whatIfTradeCurrency = value;
    },
    setContractSelectedUtility(state, value) {
        state.contractSelectedUtility = value;
    },
    setWhatIfRoute(state, value) {
        state.whatIfRoute = value;
    },
    setWhatIfObject(state, value) {
        state.whatIfObject = value;
    },
    setReportsContractId(state, value) {
        state.reportContractId = value;
    },
    setReportsClientId(state, value) {
        state.reportClientId = value;
    },
    setReportsTradingGroupId(state, value) {
        state.reportTradingGroupId = value;
    },
    setContractMarketUnit(state, value) {
        state.contractMarketUnit = value;
    },
    setContractMarketUnitName(state, value) {
        state.contractMarketUnitName = value;
    },
    setContractHasActiveTrades(state, value) {
        state.contractHasActiveTrades = value;
    },
    setIsContractExpired(state, value) {
        state.isContractExpired = value;
    },
    setGroupUserTabLast(state, value) {
        state.isGroupUserTabLast = value;
    },
    setCheckDefaultM(state, value) {
        state.isCheckDefaultM = value;
    },
    setClientCheckDefaultM(state, value) {
        state.isClientDefaultM = value;
    },
    setHomeVolumeData(state, value) {
        state.homeVolumeData = value;
    },
    setHomePowerRates(state, value) {
        state.homePowerRates = value;
    },
    setHomeGasRates(state, value) {
        state.homeGasRates = value;
    },
    setWhatIfCollectionObject(state, value) {
        state.whatIfCollection = value;
    },
    setTradingGroupsIds(state, value) {
        state.tradingGroupsIds = value;
    },
    setHomeRegionMap(state, value) {
        state.homeRegionMap = value;
    },
    setLastDay(state, value) {
        state.lastDay = value;
    },
    setPriceAreaNames(state, value) {
        state.pricingAreaNames = value;
    },
    setHasPriceAreas(state, value) {
        state.hasPriceAreas = value;
    },
}

const getters = {
    permissions: state => state.permissions,
    isLoggedIn: state => state.isLoggedIn,
    loggedInUserId: state => state.loggedInUserId,
    loggedInUserEmail: state => state.loggedInUserEmail,
    avatarUrl: state => state.avatarUrl,
    navBarItems: state => state.navBarItems,
    selectedContractId: state => state.selectedContractId,
    contractProducts: state => state.contractProducts,
    isContractSellback: state => state.isContractSellback,
    contractVolumeUnit: state => state.contractVolumeUnit,
    contractTradeUnit: state => state.contractTradeUnit,
    contractVolumeUnitName: state => state.contractVolumeUnitName,
    contractTradeUnitName: state => state.contractTradeUnitName, 
    whatIfUtilityTypeId: state => state.whatIfUtilityTypeId,
    whatIfProducts: state => state.whatIfProducts,
    whatIfTradeablePeriods: state => state.whatIfTradeablePeriods,
    whatIfPriceUnit: state => state.whatIfPriceUnit,
    whatIfTradingSymbol: state => state.whatIfTradingSymbol,
    whatIfLockedVolumeUnit: state => state.whatIfLockedVolumeUnit,
    whatIfTradeCurrency: state => state.whatIfTradeCurrency,
    contractSelectedUtility: state => state.contractSelectedUtility,
    whatIfRoute: state => state.whatIfRoute,
    whatIfObject: state => state.whatIfObject,
    reportContractId: state => state.reportContractId,
    reportClientId: state => state.reportClientId,
    reportTradingGroupId: state => state.reportTradingGroupId,
    contractMarketUnit: state => state.contractMarketUnit,
    contractMarketUnitName: state => state.contractMarketUnitName,
    contractHasActiveTrades: state => state.contractHasActiveTrades,
    isContractExpired: state => state.isContractExpired,
    isCheckDefaultM: state => state.isCheckDefaultM,
    isClientDefaultM: state => state.isClientDefaultM,
    homeVolumeData: state => state.homeVolumeData,
    homeRegionMap: state => state.homeRegionMap,
    homePowerRates: state => state.homePowerRates,
    gasPowerRates: state => state.gasPowerRates,
    whatIfCollection: state => state.whatIfCollection,
    tradingGroupsIds: state => state.tradingGroupsIds,
    lastDay: state => state.lastDay,
    pricingAreaNames: state => state.pricingAreaNames,
    hasPriceAreas: state => state.hasPriceAreas
}

export default new Vuex.Store({
    state,
    mutations,
    getters
});